import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { useTheme } from '../lib/theme/index.js';

export default function ParentToolsPage() {
  const { themeVariant } = useTheme();

  const tools = [
    {
      title: 'Spelling Bee Practice',
      description: 'Help your child practice spelling with audio pronunciation and voice recognition. Perfect for spelling bee preparation!',
      icon: '🐝',
      href: '/parent-tools/spelling-bee',
      color: 'from-yellow-100 to-orange-100',
      borderColor: 'border-yellow-300',
    },
    // More tools can be added here in the future
  ];

  return (
    <div className="min-h-screen" data-theme={themeVariant}>
      <SEO 
        title="Parent Tools - Free Resources for Parents | CampWhiz"
        description="Free tools and resources to help parents support their children's learning and development. Starting with spelling bee practice."
        url="/parent-tools"
      />
      
      {/* Minimal header */}
      <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <Link 
            to="/" 
            className="text-sm text-gray-600 hover:text-primary transition-colors"
          >
            ← Back to CampWhiz
          </Link>
        </div>
      </div>

      <main className="container mx-auto px-4 py-12 flex items-center justify-center min-h-[calc(100vh-120px)]">
        <div className="max-w-4xl w-full text-center">
          {/* Header */}
          <div className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Parent Tools
            </h1>
            <p className="text-xl text-gray-600 mb-4">
              Free resources to support your child's learning
            </p>
            <div className="flex items-center justify-center gap-2">
              <span className="text-sm text-gray-500">by</span>
              <a 
                href="/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block hover:opacity-80 transition-opacity"
              >
                <img 
                  src={themeVariant === 'teal' ? '/assets/campwhiz-logo-color.svg' : '/assets/campwhiz-logo-color2.svg'}
                  alt="CampWhiz"
                  className="h-[30px]"
                />
              </a>
            </div>
          </div>

          {/* Tools Grid */}
          <div className="flex justify-center mb-12">
            <div className="grid grid-cols-1 gap-6 w-full max-w-md">
              {tools.map((tool, index) => (
                <Link
                  key={index}
                  to={tool.href}
                  className={`group relative bg-white rounded-xl border-2 ${tool.borderColor} p-6 hover:shadow-lg transition-all duration-200 hover:-translate-y-1`}
                >
                <div className={`absolute inset-0 bg-gradient-to-br ${tool.color} opacity-0 group-hover:opacity-10 rounded-xl transition-opacity`} />
                <div className="relative">
                  <div className="text-4xl mb-4">{tool.icon}</div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-primary transition-colors">
                    {tool.title}
                  </h2>
                  <p className="text-gray-600 text-sm">
                    {tool.description}
                  </p>
                  <div className="mt-4 text-primary font-medium text-sm group-hover:underline">
                    Try it now →
                  </div>
                </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Footer note */}
          <div className="text-center text-sm text-gray-500">
            <p>More tools coming soon! Have a suggestion? <a href="mailto:hello@campwhiz.com" className="text-primary hover:underline">Let us know</a>.</p>
          </div>
        </div>
      </main>
    </div>
  );
}

